export default __webpack_public_path__ + "static/media/uploadfile.3e5ee09d.svg";